<template>
    <div v-if="loaded">
        <h2 class="site-title">{{ $t('nav.complementary_materials') }}</h2>
        <v-subheader>
            <span class="mr-5">{{ complementary.label }}</span>
            <material-form :type="complementary.type" :label="complementary.label">
                <template v-slot:activator="{ dialog }">
                    <v-btn
                        v-on="dialog"
                        class="mr-2" color="primary" dark
                        small>
                        <v-icon color="white">
                            mdi-plus
                        </v-icon>
                        <span>{{ $t('base.add') }}</span>
                    </v-btn>
                </template>
            </material-form>
        </v-subheader>
        <v-data-table
            :headers="additionalHeaders"
            :items="complementary.items"
            class="elevation-1"
            disable-pagination
            hide-default-footer>
            <template v-slot:item.unit="{ item }">
                {{ unitLabel(item.unit) }}
            </template>
            <template v-slot:item.tax="{ item }">
                {{ item.tax | trailingZeros }}
            </template>
            <template v-slot:item.action="{ item }">
                <material-form :item="item" :type="complementary.type">
                    <template v-slot:activator="{ dialog }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn
                                    v-on="{...tooltip, ...dialog}"
                                    class="mr-2" color="blue" dark
                                    fab
                                    small>
                                    <v-icon color="white">
                                        mdi-square-edit-outline
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('base.edit') + ' ' + item.description[$locale] }}</span>
                        </v-tooltip>
                    </template>
                </material-form>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            @click="deleteItem(item)"
                            color="orange"
                            :disabled="loading"
                            fab small
                            v-on="on">
                            <v-icon color="white">
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('base.remove') }}</span>
                </v-tooltip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import type from '@/helpers/ItemType'
import units from '@/helpers/units'
import MaterialForm from './materials/MaterialForm'

export default {
    components: {
        MaterialForm
    },
    computed: {
        planks() {
            return {
                type: 'planks',
                label: type.plank.label,
                items: this.$store.getters.items(type.plank.id)
            }
        },
        joists() {
            return {
                type: 'joists',
                label: type.joist.label,
                items: this.$store.getters.items(type.joist.id)
            }
        },
        slats() {
            return {
                type: 'slats',
                label: type.slat.label,
                items: this.$store.getters.items(type.slat.id)
            }
        },
        // additional() {
        //     return {
        //         type: 'complementary',
        //         label: type.complementary.label,
        //         items: this.$store.getters.items(type.complementary.id)
        //     }
        // },
        complementary() {
            return {
                type: 'complementary',
                label: type.complementary.label,
                items: this.$store.getters.items(type.complementary.id)
            }
        },
        commonHeaders() {
            return [
                {
                    text: this.$t('materials.description'),
                    value: 'description.' + this.$locale
                },
                {
                    text: this.$t('materials.firmao_product_id'),
                    value: 'firmao_product_id'
                },
                {
                    text: this.$t('materials.price'),
                    value: 'price'
                },
                {
                    text: this.$t('materials.tax'),
                    value: 'tax'
                },
                {
                    text: this.$t('materials.unit'),
                    value: 'unit'
                }
            ]
        },
        baseHeaders() {
            return this.commonHeaders.concat([
                {
                    text: this.$t('base.actions'),
                    value: 'action',
                    sortable: false,
                    align: 'center'
                }
            ])
        },
        additionalHeaders() {
            return this.commonHeaders.concat([
                {
                    text: this.$t('materials.package'),
                    value: 'package'
                },
                {
                    text: this.$t('materials.amount_for_unit'),
                    value: 'amount_for_unit'
                },
                {
                    text: this.$t('base.actions'),
                    value: 'action',
                    sortable: false,
                    width: 150,
                    align: 'center'
                }
            ])
        }
    },
    name: "Materials",
    data() {
        return {
            items: [],
            loading: false,
            loaded: false,
        }
    },
    methods: {
        unitLabel(id) {
            let unit = units.find(unit => unit.id == id)
            return unit ? unit.label : ""
        },
        deleteItem(item) {
            if (confirm(this.$t('materials.delete-item', {product: item.description[this.$locale]}))) {
                this.loading = true
                this.$http.delete('items/' + item.id)
                    .then(() => {
                        this.$store.commit('removeItem', item.id)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        }
    },
    mounted() {
        this.loading = true
        this.$store.dispatch('prepareMaterials')
            .then(() => {
                this.loading = false
                this.loaded = true
            })
            .catch(() => {
                this.loading = false
            })
    }
}
</script>

<style scoped>
.calculable-items-container {
    margin-bottom: 20px;
}
</style>
